module.exports = __webpack_public_path__ + "static/media/twitter-logo.ee3fd44d.png";